import contextCreator from "../contextCreator";
import appReducer, { initialState } from "./app.reducer";

// eslint-disable-next-line react-hooks/rules-of-hooks
const [state, dispatch, provider] = contextCreator(appReducer, initialState);

export const useAppState = state;
export const useAppDispatch = dispatch;
export const AppProvider = provider;
